<template>
  <div class="manual-payments">
    <breadcrumbs :breadcrumbsData="breadcrumbsData" />
    <div class="filters">
      <div class="search">
        <div class="option">
          <span>ASIN</span>
          <artmisads-input v-model:value="filters.asin" @press-enter="getPartData({})"
            placeholder="Enter ASIN"></artmisads-input>
        </div>
        <div class="option">
          <span>ProductId</span>
          <artmisads-input v-model:value="filters.productId" @press-enter="getPartData({})"
            placeholder="Enter productId"></artmisads-input>
        </div>
      </div>
      <div class="button">
        <artmisads-button isSquare="true" type="primary" style="margin-right: 8px;" :loading="load"
          @click="searchList">搜索</artmisads-button>
        <artmisads-button isSquare="true" @click="onReset">重置</artmisads-button>
      </div>
    </div>
    <div class="add">
      <artmisads-button isSquare="true" type="primary" @click="uploadManualPayment">上传</artmisads-button>
      <artmisads-button isSquare="true" type="primary" @click="addManualPayment">新建</artmisads-button>
    </div>
     <div class="table-data">
        <artmisads-table v-model:pagination="pagination" :columns="columns" :data-source="data" :change="onTableChange"
        :loading="load" :scroll="{ y: tableScrollHeight }">
          <template #bodyCell="{ column, text, index, record }">
          <template v-if="column.key === 'action'">
            <div class="actionBox">
              <a href="javascript:void(0)" @click="remove(record)">删除</a>
            </div>
            </template>
          </template>
       </artmisads-table>
     </div>
     <addSensitive ref="addSensitiveRef" @submit="onSubmit" />
     <uploadSensitive ref="uploadSensitiveRef" @submit="onSubmit" />
  </div>
</template>
<script setup>
import { ref,reactive } from 'vue'
import breadcrumbs from "../breadcrumbs.vue"
import { useTableScrollHeight } from "@/utils/useTableScrollHeight"
import { financeApi } from "~/server/operator/finance"
import { Modal, message } from 'ant-design-vue'
import addSensitive from './components/addSensitive.vue'
import uploadSensitive from './components/uploadSensitive.vue'
const addSensitiveRef=ref(null)
const uploadSensitiveRef=ref(null)
const pagination = reactive({
  current: 1,
  defaultPageSize: 10,
  size: 10,
  pageSize: 10,
  total: 0,
  pageSizeOptions: ['10', '20', '50', '100'],
  showSizeChanger: true,
})
const columns = [
  {
    title: "ASIN",
    key: "asin",
    dataIndex: "asin",
    align: 'center'
  },
  {
    title: "Product",
    dataIndex: "productTitle",
    key: "productTitle",
    align: 'center'
  },
  {
    title: "ProductId",
    dataIndex: "productId",
    key: "productId",
    align: 'center'
  },
  {
    title: "Brand",
    dataIndex: "brandName",
    key: "brandName",
    align: 'center'
  },
  {
    title: "Marketplace",
    dataIndex: "marketplace",
    key: "marketplace",
    align: 'center'
  },
 
  {
    key: "action",
    fixed: 'right',
    title: "操作",
    align: 'center'
  },
]
const load = ref(false)
const data = ref([])
const breadcrumbsData = ref({
  title: "Sensitive Products",
  des: "",
  links: [
    {
      name: "Home",
      path: "/operator/users",
    },
    {
      name: "Operation",
      path: "/operator/operation/manualPayments",
    },
    {
      name: "Sensitive Products",
      path: "/operator/operation/sensitive",
    },
  ]
})
const filters = ref({
  asin: '',
  productId: ""
})
const { tableScrollHeight } = useTableScrollHeight({
  selector: '.table-data',
  bottomSpace: 280,
  minHeight: 200,
  maxHeight: 1000,
  defaultHeight: 350
})
const onTableChange = ({ current, pageSize }) => {
  pagination.current = current
  pagination.size = pageSize
  pagination.pageSize = pageSize
  getData({ page: current, size: pageSize })
}
const getData = (params) => {
load.value = true
  if (Object.keys(params).length === 0) {
    pagination.current = 1
  }
  let _params = {
    page: 1,
    size: pagination.size,
    // marketplace: filters.marketplace,
    // sellerId: filters.sellerId,
    // bd: filters.bd
  }
  let newparams = { ..._params, ...params }
  newparams = Object.keys(newparams).reduce((acc, key) => {
    if (
      newparams[key] !== null &&
      newparams[key] !== undefined &&
      newparams[key] !== ""
    ) {
      acc[key] = newparams[key]
    }
    return acc
  }, {})
   financeApi.productSensitiveAsinList(newparams).then(res => {
    data.value = res.data.data || []
    pagination.total = res.data.total || 0
    load.value = false
  })
}
const searchList=()=>{
  getData({
    asin: filters.value.asin,
    productId: filters.value.productId,
  })
}
const onReset = () => {
  filters.value = {
    asin: '',
    productId: ""
  }
  getData({})
}
const refreshData = (reset=true) => {
  getData({})
  if(reset){
  onReset()
  }
}
const remove=(item)=>{
  console.log(item,'item')
   Modal.confirm({
    title: '确认删除该条记录吗？',
    okText: '确认',
    cancelText: '取消',
    okType: 'danger',
    onOk: () => {
      financeApi.productSensitiveAsinDelete({ id: item.id }).then(res => {
        if (res.success) {
          message.success('删除成功')
          refreshData(false)
        } else {
          message.error(res.message || '取消失败')
        }
      })
    }
  })

}
const onSubmit=()=>{
  getData({})
}
const addManualPayment=()=>{
    addSensitiveRef.value.show()
}
const uploadManualPayment=()=>{
  uploadSensitiveRef.value.show()
}
getData({})
</script>
<style scoped lang="less">
.add {
  display: flex;
  justify-content: flex-end;
  margin: 16px 0;
  gap: 12px;
}
.table-data {

  border-radius: 8px;
  border: 1px solid #fff;
  border-radius: 12px;
  overflow: hidden;
  border-radius: 12px;
  background-color: var(--color-white);
  padding: 15px;

  :deep(.ant-table) {
    border-radius: 8px 8px 0 0;
  }

  :deep(.ant-table-cell) {
    padding-left: 8px;
    padding-right: 8px;

    >a {
      color: var(--primary);

      &:hover {
        color: var(--primary-hover);
      }
    }
  }

  :deep(.ant-table-thead) {
    border-radius: 8px 8px 0 0;
  }

  .user {
    flex: 1;

    .user-name {
      color: var(--dark-1);
      font-weight: 500;
      font-size: 16px;
      letter-spacing: 0.4px;
      line-height: 20px;

      >span {
        font-weight: 400;
        margin-left: 4px;
      }
    }

    .user-email {
      font-weight: 500;
      font-size: 12px;
      color: var(--dark-2);
      letter-spacing: 0.3px;
      line-height: 16px;
      padding: 10px 0;
    }

    .user-id {
      height: 16px;
      font-weight: 500;
      font-size: 12px;
      color: var(--dark-3);
      letter-spacing: 0.3px;
      line-height: 16px;
    }
  }

}
.manual-payments {
  padding: 16px;
  padding-top: unset;
  width: 100%;
}

.filters {
  display: flex;
  justify-content: space-between;

  .search {
    display: flex;

    .option {

      >span {
        margin-right: 8px;
      }

      display: flex;
      align-items: center;
      margin-right: 24px;
    }
  }
}
</style>
